/**
 * Ported from Client/Assets/NetworkModels/GameEnums.cs
 * (namespace GameStars.Models.NetworkModels.Enums).
 *
 * Web is appended at value 3 in the canonical pardis-shared enum; existing native values remain stable.
 */

export enum PlatformTypes {
  Windows = 0,
  Android = 1,
  Ios = 2,
  Web = 3,
}

export enum GameName {
  Hokm = 0,
  Backgammon = 1,
  Blackjack = 2,
}

export enum GameState {
  Wait = 0,
  Running = 1,
  Finished = 2,
  Recovered = 3,
}

export enum GameWaitState {
  Created = 0,
  WaitForConfirm = 1,
}

/** Per-game variant carried in GameInfoModel.GameType (a short). */
export enum HokmType {
  Normal = 0,
  WithNaras = 1,
}

export enum BackgammonType {
  Nard = 0,
  BackGammon = 1,
}

export enum GameTime {
  Relax = 0,
  Normal = 1,
  Fast = 2,
}

export enum Role {
  None = 0,
  Player1 = 1,
  Player2 = 2,
}

export enum BlackjackActions {
  Hit = 0,
  Stand = 1,
  Bet = 2,
}

export enum RoomName {
  Connect = 0,
  MainMenu = 1,
  Payment = 2,
  Profile = 3,
  Ticket = 4,
  Login = 5,
  Register = 6,
  Backgammon = 7,
  Hokm = 8,
  CreateBackgammon = 9,
  CreateHokm = 10,
  Ready = 11,
  SearchGame = 12,
  HokmPreview = 13,
  NewGame = 14,
  Blackjack = 15,
  OnlineList = 16,
  PasswordChange = 17,
}

export enum Hokm {
  NotSet = -1,
  Clubs = 0,
  Diamonds = 1,
  Hearts = 2,
  Spades = 3,
  Naras = 4,
  Saras = 5,
  AsNaras = 6,
  AsSaras = 7,
}

/** Support-ticket category (sent on the wire as the enum NAME string, not the number). */
export enum TicketType {
  General = 0,
  Game = 1,
  Transaction = 2,
  Payback = 3,
}

export enum TicketStatus {
  New = 0,
  Readed = 1,
  InProgress = 2,
  Done = 3,
  Offensive = 4,
  Empty = 5,
}
